import { useParams } from 'react-router-dom'

export interface JobRouteParams {
  jobId: string
}

export function useJobRouteParams() {
  return useParams<JobRouteParams>()
}
